import Header from "@/components/header";
import { Button, Checkbox, Grid, Group, Stack, Text } from "@mantine/core";

import LoadingPillItems from "@/components/loading/loadingPillItems/loadingPillItems";
import CustomStepper from "@/components/stepper";
import { useGetDailyAppointment } from "@/services/appointment/hooks/useGetDailyAppointment";
import useScheduleStore from "@/store/schedule";
import { notifications } from "@mantine/notifications";
import { IconChevronLeft } from "@tabler/icons-react";
import moment from "moment-jalaali";
import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { stepperAppointment } from "../type";
import { TimSelectorFooter } from "./components/timSelectorFooter";
import { TimSelectorHeader } from "./components/timeSelectorHeader";
import { getTimeSlots } from "./helper";
import classes from "./appointment.module.css";

function SelectTime() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const {
    selectedAppointmentDate,
    selectService,
    setSelectedAppointmentTime,
    setSelectedAppointmentDate,
  } = useScheduleStore();

  const [selectedAppointment, setSelectedAppointment] = useState<string[]>([]);
  const { isLoading } = useGetDailyAppointment({
    fromDate: moment(selectedAppointmentDate).format("YYYY-MM-DD"),
    toDate: moment(selectedAppointmentDate).format("YYYY-MM-DD"),
  });

  useEffect(() => {
    if (state) {
      setSelectedAppointmentDate({
        selectedAppointmentDate: state?.date?.day
          ? state?.date?.day
          : new Date(),
      });
      const timeNow = moment().format("HH:mm");
      const selectTime = moment(state?.date?.time, "HH:mm").format("HH:mm");
      if (timeNow < selectTime)
        setSelectedAppointment([
          moment(state?.date?.time, "HH:mm").format("HH:mm"),
        ]);
    } else {
      setSelectedAppointmentDate({
        selectedAppointmentDate: new Date(),
      });
    }
  }, [state]);

  const submit = () => {
    if (selectedAppointment?.length === 0) {
      notifications.show({
        message: "لطفا زمان نوبت را مشخص نمایید",
        color: "yellow",
      });
      return;
    }
    setSelectedAppointmentTime({
      selectedAppointmentTime: selectedAppointment,
    });

    navigate("/dashboard/schedule/save");
  };

  const slots = useMemo(
    () =>
      getTimeSlots(
        "",
        "",
        selectService?.durationPartInMinute || 0,
        selectedAppointmentDate
      ),
    [selectedAppointmentDate]
  );

  useEffect(() => {
    setSelectedAppointmentTime({
      selectedAppointmentTime: [],
    });
    setSelectedAppointment([]);
  }, [selectedAppointmentDate]);

  return (
    <>
      <Stack h="100svh">
        <Header showBack showHome title="افزودن نوبت" />
        <CustomStepper steppers={stepperAppointment} active={2} />
        <TimSelectorHeader />
        <Stack
          h={"calc(100svh - 260px)"}
          styles={{
            root: {
              flexGrow: 1,
              overflow: "hidden",
              overflowY: "auto",
            },
          }}
          px="lg"
        >
          {isLoading ? (
            <LoadingPillItems count={8} />
          ) : (
            <Checkbox.Group
              value={selectedAppointment}
              onChange={setSelectedAppointment}
            >
              <Grid>
                {slots?.map((item) => (
                  <Grid.Col key={item?.start} span={4}>
                    <Checkbox.Card
                      radius="md"
                      className={classes.root}
                      withBorder
                      color="green"
                      value={item.start}
                      key={item.start}
                      disabled={item?.disabled}
                    >
                      <Group gap="5">
                        <Checkbox.Indicator color="green" />
                        <Text>{item.start}</Text>
                      </Group>
                    </Checkbox.Card>
                  </Grid.Col>
                ))}
              </Grid>
            </Checkbox.Group>
          )}
        </Stack>
        <Stack>
          <TimSelectorFooter />
        </Stack>
        <Stack px="lg">
          <Button
            type="submit"
            size="md"
            my="md"
            fullWidth
            form="add-customer"
            onClick={submit}
          >
            <Group gap="xs">
              <Text>مرحله بعد</Text>
              <IconChevronLeft size={20} />
            </Group>
          </Button>
        </Stack>
      </Stack>
    </>
  );
}

export default SelectTime;
